import React, { useEffect, useState } from 'react';

import 'react-dom'


import { useAppState } from "./../../state";

// react-bootstrap components
import {
    Badge,
    Button,
    Card,
    Collapse,
    Form,
    InputGroup,
    Navbar,
    Nav,
    OverlayTrigger,
    Table,
    Tooltip,
    Container,
    Row,
    Col,
} from "react-bootstrap";



function CloudRoutersPage() {  

    return (
        <>
            <Container fluid id="cloudRouters">

               <div>test</div>
            </Container>
        </>
    )
}




export default CloudRoutersPage;






